import { useEffect, useMemo, useState } from 'react'
import Overview from './dense'

type Props = {
  appView: boolean
  isWindowScroll: boolean
  property: TopHap.ExtendedProperty,
  children?: React.ReactNode
}

const OVERVIEW_HEIGHT = 52
const StickOverview: React.FC<Props> = ({ property, appView, isWindowScroll, children }) => {
  const top = useMemo(
    () =>
      (!appView && isWindowScroll ? 110 : 0) + OVERVIEW_HEIGHT,
    [appView, isWindowScroll]
  )
  const [stuck, setStuck] = useState(false)
  useEffect(() => {
    if (typeof (window) !== 'undefined') {
      const factsObserver = new IntersectionObserver(
        entries => {
          setStuck(entries[0].intersectionRatio < 1)
        },
        { threshold: [0, 1] }
      )

      const factsContainer = document.getElementById('overview-sticky-trigger')
      factsContainer && factsObserver.observe(factsContainer)

      return () => factsObserver.disconnect()
    }
  }, [])

  return (
    <>
      <div id='overview-sticky-trigger' style={{ marginTop: -(top + 1), marginBottom: top + 1 }} />
      <div className='sticky z-30' style={{ top }}>
        {stuck && <Overview className='absolute inset-x-0 bottom-full' property={property as TopHap.ExtendedProperty} />}
        {children}
      </div>
    </>
  )
}

export default StickOverview
